import { getActiveRootSpan } from './platform';
import {
  LocalScanLookupPath,
  LocalScanMatchStatus,
  ScannerType,
} from '@/components/scanner/scanner-types';

export enum Feature {
  LocalScan = 'local_scan',
  OrderGuide = 'order_guide',
  OrderSummary = 'order_summary',
}

export enum SpanAttribute {
  DraftOrderItemCount = 'draft_order.item_count',
  DraftOrderSmartOrderUUID = 'draft_order.smart_order_uuid',
  DraftOrderUUID = 'draft_order.uuid',
  FeatureName = 'feature.name',
  LocalScanCatalogRefreshSupplierCatalogCount = 'local_scan.catalog_refresh.supplier_catalog_count',
  LocalScanCatalogRefreshSupplierCatalogSize = 'local_scan.catalog_refresh.supplier_catalog_size',
  LocalScanCatalogRefreshTrigger = 'local_scan.catalog_refresh.trigger',
  LocalScanCatalogRefreshVisibleVariantPackCount = 'local_scan.catalog_refresh.visible_variant_pack_count',
  LocalScanCatalogRefreshVisibleVariantPackIdsSize = 'local_scan.catalog_refresh.visible_variant_pack_size',
  LocalScanEventCode = 'local_scan.event.code',
  LocalScanEventLookupPath = 'local_scan.event.lookup_path',
  LocalScanEventMatchStatus = 'local_scan.event.match_status',
  LocalScanEventScannerType = 'local_scan.event.scanner_type',
  OrderGuideItemCount = 'order_guide.item_count',
}

export enum LocalScanCatalogRefreshTrigger {
  FirstOpen = 'first_open',
  ManualFresh = 'manual_fresh',
  ManualStale3Days = 'manual_stale_3_days',
  ManualStale7Days = 'manual_stale_7_days',
  QueryChanged = 'query_changed',
}

interface FeatureAttributes {
  [Feature.OrderGuide]: {
    [SpanAttribute.OrderGuideItemCount]: number;
  };
  [Feature.OrderSummary]: {
    [SpanAttribute.DraftOrderItemCount]: number;
    [SpanAttribute.DraftOrderSmartOrderUUID]?: string;
    [SpanAttribute.DraftOrderUUID]?: string;
  };
  [Feature.LocalScan]: {
    [SpanAttribute.LocalScanCatalogRefreshSupplierCatalogCount]: number;
    [SpanAttribute.LocalScanCatalogRefreshVisibleVariantPackCount]: number;
    [SpanAttribute.LocalScanCatalogRefreshSupplierCatalogSize]: number;
    [SpanAttribute.LocalScanCatalogRefreshVisibleVariantPackIdsSize]: number;
    [SpanAttribute.LocalScanCatalogRefreshTrigger]: LocalScanCatalogRefreshTrigger;
    [SpanAttribute.LocalScanEventLookupPath]: LocalScanLookupPath;
    [SpanAttribute.LocalScanEventMatchStatus]: LocalScanMatchStatus;
    [SpanAttribute.LocalScanEventScannerType]: ScannerType;
    [SpanAttribute.LocalScanEventCode]: string;
  };
}

export const setFeatureSpanAttributes = <F extends Feature>(
  feature: F,
  attrs: FeatureAttributes[F],
) => {
  getActiveRootSpan()?.setAttributes({
    [SpanAttribute.FeatureName]: feature,
    ...attrs,
  });
};
